<template>
  <div>
    <v-parallax height="auto" src="@/assets/images/back-page.webp">
      <section class="banner redirect">
        <!-- MOBILE -->
        <section class="redirect hidden-md-and-up px-2" cols="12">
          <h2 class="banner__title">
            {{ getTitle }}
          </h2>
          <p class="banner__text mb-12">{{ getSubtitle }}</p>
          <v-img class="mb-2" src="@/assets/images/back-redirect-sm.webp" />
          <p class="banner__text mb-6" v-html="getContentTxt"></p>
          <v-btn
            class="banner__btn mb-6"
            :href="getRedirect"
            @click="register"
            target="_blank"
            dark
            x-large
            color="#3badff"
            block
          >
            IR A POSTULAR
          </v-btn>
        </section>

        <!-- DESKTOP -->
        <section class="redirect hidden-sm-and-down">
          <v-row justify="center" class="ma-0 pa-0">
            <v-col class="text-center pa-0 ma-0" cols="12" sm="12" md="12" lg="12">
              <v-row justify="center" class="ma-0 pa-0">
                <v-col sm="12" md="10" lg="7" xl="5" class="pa-0 ma-0 txt-view">
                  <h1 class="banner__title">{{ getTitle }}</h1>
                </v-col>
                <v-col cols="8" sm="9" md="10" lg="8" class="ma-0 pa-0">
                  <p class="banner__text">
                    {{ getSubtitle }}
                  </p>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row
            justify="center"
            justify-md="start"
            align-md="start"
            align="center"
            class="background-img mx-xl-10 mx-md-3 py-md-10"
          >
            <v-col md="7" lg="8" xl="9" class="d-flex flex-column mx-lg-10">
              <v-col lg="6" xl="5" class="txt-redirect">
                <div class="banner__text" v-html="getContentTxt"></div>
                <v-btn
                  class="banner__btn mt-6"
                  :href="getRedirect"
                  @click="register"
                  target="_blank"
                  dark
                  x-large
                  color="#3badff"
                >
                  IR A POSTULAR
                </v-btn>
              </v-col>
            </v-col>
          </v-row>
        </section>
      </section>
    </v-parallax>

    <Footer />
  </div>
</template>

<script>
import { meta } from "@/libs/mixins";

export default {
    name: "Redirect",

    props: ["redirect", "offerId"],

    mixins: [meta],

    metaInfo() {
        return this.getMetaInfo({
            title: "Saliendo del sitio",
        });
    }, 

    computed: {
        getTitle() {
            return "¡Muchas gracias por buscar un Trabajo con Sentido con nosotros!";
        },
        getSubtitle() {
            return "Seguimos trabajando día a día en incorporar más Trabajos con Sentido para nuestra comunidad.";
        },
        getContentTxt() {
            return `A continuación serás redireccionado a otra página ya que este proceso se maneja <b class="blue--text">fuera de nuestra plataforma.</b>
                  Cualquier consulta podrás realizarla directamente a la organización a la que postulas.
                  <br> <br> <b>¡Te deseamos mucho éxito!</b>`;
        },
        getRedirect() {
            return this.redirect.startsWith("http")
                ? this.redirect 
                : `http://${ this.redirect }`;
        },
    },

    methods: {
        register() {
            this.$store.dispatch("users/redirect", {
                offerId: this.offerId
            });
        }
    },
};
</script>
